module.exports = __webpack_public_path__ + "static/img/about-contact.03f9c225.png";